import type { PlanogramItemOrientation } from "@CommonTypes/merchflow/pog/item";

// Avoid losing an exact cap span to floating-point precision, e.g. 19.9999999 / 10.
const DIMENSION_PRECISION_OFFSET = 0.000001;

export const getCappingSpanCount = (primarySpan: number, capSpan: number) => {
  if (primarySpan <= 0 || capSpan <= 0) return 0;

  return Math.max(1, Math.floor((primarySpan + DIMENSION_PRECISION_OFFSET) / capSpan));
};

export const shouldRotateFacingImage = (orientation: PlanogramItemOrientation) => {
  return orientation === "FRONT2" || orientation === "SIDE2" || orientation === "TOP2";
};
